<div class="product-descomplica-container"
     [ngClass]="{'recommended': productData.preferred}">

    <div class="header" [ngClass]="{'recommended': productData.preferred, 'notRecommended': !productData.preferred}"
         >
        <span class="recommendedText" *ngIf="productData.preferred; else notRecommended">Recomendado</span>
        <ng-template #notRecommended>
            <span class="notRecommendedText"></span>
        </ng-template>
    </div>
    <div class="card">

        <div class="planName">
            <p class="name">{{productData.cardTitle}}</p>
            <p class="detail">{{this.periodicity}}</p>
        </div>
        <div class="planPrice">
            <span class="totalValue" *ngIf="isAppliedDiscounts()">
                De <span class="censored">R$ {{getValue('baseValue')}}</span> por:
            </span>
            <span class="currencyPerMonth">
                <strong>R$ {{getValue('monthlyValue')}}</strong> / mês
            </span>
        </div>
        <div class="button">
            <button  (click)="onClick()">
                <span class="buttonText">{{productData.buttonName}}</span>
            </button>
        </div>
    </div>
</div>
